import React, { useEffect } from "react";
import AboutMe from "../components/home-components/AboutMe";
import Awards from "../components/home-components/Awards.js";
import Skills from "../components/home-components/Skills.js";
import Projects from "../components/home-components/Projects.js";
import Gallery from "../components/home-components/Gallery.js";
import "../styles/pages/home.scss";

export default function Home() {
  useEffect(() => {
    const sectionId = localStorage.getItem("scrollTarget");
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        localStorage.removeItem("scrollTarget");
      }
    }
  }, []);

  return (
    <div className="home">
      <section className="section-1">
        <div className="title">
          {"<Software Engineer based in "}{" "}
          <span className="highlight-1">London.</span>{" "}
          {"Currently crafting digital products at"}{" "}
          <span className="highlight-2">Imperial College London.</span> {"/>"}
        </div>
      </section>
      {/* <hr /> */}
      <section className="section-2" id="about-me">
        <AboutMe />
      </section>
      {/* <hr /> */}
      <section className="section-3" id="awards">
        <Awards />
      </section>
      {/* <hr /> */}
      <section className="section-4" id="skills">
        <Skills />
      </section>
      {/* <hr /> */}
      <section className="section-5" id="projects">
        <Projects />
      </section>
      <section className="section-6" id="gallery">
        <Gallery />
      </section>
    </div>
  );
}
